export default {
  'memos.field.subject': 'Subject',
  'memos.field.created_by': 'Created By',
  'memos.field.created_at': 'Created At',
  'memos.field.updated_at': 'Updated At',
  'memos.empty': 'No Memo',
  'memos.title': 'Memo',
  'memos.delete.confirm.title': 'Are you sure to delete this memo?',
  'memos.deleted.success': 'Successfully deleted Memo',
  'memos.delete.tooltip': 'Delete Memo',
  'memos.added.success': 'Successfully added Memo',
  'memos.updated.success': 'Successfully updated Memo',
  'memos.edit_memo.tooltip': 'Edit Memo',
  'memos.auto_load.alert.tooltip': 'Display this memo in matching shipments',
  'memos.auto_load.inherited.tooltip': 'Loaded from Contact: {contact} ({roles})',
  'memos.auto_load.settings.description':
    'Alert-enabled Contact memos are displayed automatically when the Contact is assigned to a selected role.',
  'memos.auto_load.module.ocean_export': 'Ocean Export',
  'memos.auto_load.module.ocean_import': 'Ocean Import',
  'memos.auto_load.module.air_export': 'Air Export',
  'memos.auto_load.module.air_import': 'Air Import',
  'memos.auto_load.module.truck': 'Trucker',
  'memos.auto_load.module.misc': 'Misc.',
  'memos.auto_load.level.mbl': 'Master B/L',
  'memos.auto_load.level.hbl': 'House B/L',
  'memos.auto_load.role.agent': 'Overseas Agent',
  'memos.auto_load.role.carrier': 'Carrier',
  'memos.auto_load.role.consignee': 'Consignee',
  'memos.auto_load.role.shipper': 'Shipper',
  'memos.auto_load.role.actual_shipper': 'Actual Shipper',
  'memos.auto_load.role.notify': 'Notify',
  'memos.auto_load.role.additional_notify': 'Additional Notify',
  'memos.auto_load.role.customer': 'Customer',
  'memos.auto_load.role.bill_to': 'Bill To',
  'memos.auto_load.role.broker': 'Customs Broker',
  'memos.auto_load.role.trucker': 'Trucker',
  'memos.auto_load.role.forwarding_agent': 'Issuing Carrier/Agent',
};
